import { action, atom } from "@reatom/core"

import {
    SurveyAnswer,
    SurveyMultiAnswerValue,
    Choices,
} from "modules/NewClientSurvey/common/interface"
import { SurveyAnswersStorage, filterObject } from "modules/NewClientSurvey/common/utils"
import { AnswerType } from "modules/NewClientSurvey/common/constants"

const dataStorage = SurveyAnswersStorage.getInstance().get()

export const answersAtom = atom<Record<string, SurveyAnswer>>(dataStorage?.answers || {}, "answers")

answersAtom.onChange((ctx, state) =>
    SurveyAnswersStorage.getInstance().updateStore("answers", state)
)

export const changeInputAnswers = action(
    (
        ctx,
        questionId: string,
        value: string | number,
        sequence_number: number,
        type: AnswerType,
        ref: string
    ) => {
        answersAtom(ctx, (state) => {
            const filteredState = filterObject(state, "sequence_number", sequence_number)
            const newState = { ...filteredState }
            newState[questionId] = { value, type, sequence_number, ref }
            return newState as Record<string, SurveyAnswer>
        })
    }
)

export const changeMultiSelectAnswers = action(
    (
        ctx,
        questionId: string,
        choice: Choices,
        sequence_number: number,
        type: AnswerType,
        ref: string
    ) => {
        answersAtom(ctx, (state) => {
            let choicesValue = {
                ...(state[questionId]?.value as SurveyMultiAnswerValue),
            }
            const choiceValue = choicesValue?.[choice.id]?.value

            if (choiceValue) {
                delete choicesValue?.[choice.id]
            } else {
                choicesValue = {
                    ...choicesValue,
                    [choice.id]: {
                        value: !choicesValue?.[choice.id]?.value,
                        ref: choice.ref,
                    },
                }
            }

            const filteredState = filterObject(state, "sequence_number", sequence_number)

            return {
                ...filteredState,
                [questionId]: {
                    value: choicesValue,
                    type,
                    sequence_number,
                    ref,
                },
            } as Record<string, SurveyAnswer>
        })
    }
)
